<script>
  import { Popover } from 'flowbite-svelte';
  import { trackEvent } from '@button/ui/utils';

  export let shortlinkName = '';
  export let shortlinkId = '';
</script>

<button
  id={shortlinkId}
  classes="grid w-100 h-10 text-gray-900 hover:text-blue-500"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 96 960 960"
    width="24"
  >
    <path
      class="hover:text-blue-600"
      d="M520 936v-80h80v80h-80Zm-80-80V656h80v200h-80Zm320-120V576h80v160h-80Zm-80-160v-80h80v80h-80Zm-480 80v-80h80v80h-80Zm-80-80v-80h80v80h-80Zm360-280v-80h80v80h-80ZM170 406h140V266H170v140Zm-50 50V216h240v240H120Zm50 430h140V746H170v140Zm-50 50V696h240v240H120Zm530-530h140V266H650v140Zm-50 50V216h240v240H600Zm80 480V816h-80v-80h160v120h80v80H680ZM520 656v-80h160v80H520Zm-160 0v-80h-80v-80h240v80h-80v80h-80Zm40-200V296h80v80h80v80H400Zm-190-90v-60h60v60h-60Zm0 480v-60h60v60h-60Zm480-480v-60h60v60h-60Z"
    /></svg
  >
</button>

<Popover
  class="w-84 h-84 !fixed z-50 p-0"
  title={shortlinkName}
  triggeredBy={`#${shortlinkId}`}
  trigger="click"
>
  <img
    class="h-64 w-64"
    src={`${window.location.origin}/qrcode/${shortlinkId}`}
    alt={`QR code for ${shortlinkName}`}
  />
  <div class="mx-6 mb-5 mt-[-10px] flex justify-center gap-x-2">
    <a
      class="flex w-1/2 justify-center gap-x-1 rounded-md bg-buttonBg p-1 text-xs leading-[22px] hover:bg-buttonBlue/10"
      href={`${window.location.origin}/qrcode/${shortlinkId}?dl=1&type=svg`}
      on:click={() => {
        trackEvent('qrcode-download', {
          event_category: 'qrcode',
          event_label: 'svg',
        });
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="22"
        viewBox="0 96 960 960"
        width="22"
        ><path
          d="M220 896q-24 0-42-18t-18-42V693h60v143h520V693h60v143q0 24-18 42t-42 18H220Zm260-153L287 550l43-43 120 120V256h60v371l120-120 43 43-193 193Z"
        /></svg
      >
      SVG</a
    >
    <a
      class="flex w-1/2 justify-center gap-x-1 rounded-md bg-buttonBg p-1 text-xs leading-[22px] hover:bg-buttonBlue/10"
      href={`${window.location.origin}/qrcode/${shortlinkId}?dl=1&type=png`}
      on:click={() => {
        trackEvent('qrcode-download', {
          event_category: 'qrcode',
          event_label: 'png',
        });
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="22"
        viewBox="0 96 960 960"
        width="22"
        ><path
          d="M220 896q-24 0-42-18t-18-42V693h60v143h520V693h60v143q0 24-18 42t-42 18H220Zm260-153L287 550l43-43 120 120V256h60v371l120-120 43 43-193 193Z"
        /></svg
      >
      PNG</a
    >
  </div>
</Popover>

<style lang="postcss">
  svg:hover path {
    fill: rgb(37 99 235);
  }
</style>
